<form [formGroup]="mainForm">
  <nb-card>
    <nb-card-header>
      <div class="title">
          Deactivate Account
        </div>
      </nb-card-header>
    <nb-card-body>
      <textarea #reason nbInput rows="4" placeholder="Inactive Reason" fullWidth
        formControlName="reason"
        ></textarea>
    </nb-card-body>
    <nb-card-footer>
      <div class="row justify-content-between">
        <div>
          <button nbButton status="primary" class="button-save" (click)="save(reason.value)" type="button"
          [disabled]="this.mainForm.invalid">
            Yes
          </button>
        </div>
        <div>
          <button nbButton status="info" class="button-cancel" (click)="cancel()" type="button">
            No
          </button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</form>
